// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
// See https://jira.tamg.io/browse/WP-2462
import * as React from 'react';
import classnames from '@ta/common.classnames';
import styles from './ContainerSheet.css';

type Props = {|
  /** Handles CSS overflow of content in the Modal.
   *  When true, allows overflow of content to be handled on sub-elements when needed.
   */
  disableBodyScroll?: boolean,
  /** Allow the content of the modal to render outside of it */
  overflowVisible?: boolean,
  /** Whether or not the corners are rounded */
  roundedCorners?: boolean,
  /** Disables the 90vh height constraint */
  unconstrainedHeight?: boolean,
  /** The background color of the container, white by default */
  backgroundColor?: string,
  /** Optional custom style to be passed in */
  customClass?: string,
  /** Optional handler for modal scroll */
  onScroll?: (SyntheticEvent<HTMLDivElement>) => mixed,
  /** Contents of the container sheet */
  children?: React.Node,
|};

/**
 * Renders a blank white sheet
 */
const ContainerSheet = ({
  disableBodyScroll,
  overflowVisible,
  roundedCorners,
  unconstrainedHeight,
  onScroll,
  backgroundColor = 'white',
  customClass,
  children,
}: Props) => {
  const className = classnames(styles.container, customClass, {
    [styles.bodyScrollDisabled]: disableBodyScroll,
    [styles.overflowVisible]: overflowVisible,
    [styles.roundedCorners]: roundedCorners,
    [styles.unconstrainedHeight]: unconstrainedHeight,
  });
  return (
    <div className={className} onScroll={onScroll} style={{ backgroundColor }}>
      {children}
    </div>
  );
};

export default ContainerSheet;
